import { useEffect } from "react";
import Banner from "../banner/Banner";
import { Container, Typography } from "@material-ui/core";
import useStyles from "./styles";

function Home() {
  const classes = useStyles();

  useEffect(() => {
    document.title = "Cosmos Offer Club";
  }, []);

  return (
    <Container maxWidth={false}>
      <Banner />
      <div
        style={{
          marginTop: "1rem",
        }}
      >
        <Typography variant="body1" gutterBottom className={classes.paragraph}>
          We at <b>COSMOS OFFER CLUB</b> are professional manufacturers/dealers
          affiliates who specializes in promoting the diverse set of lines and
          products from the most reputed and quality dealers worldwide. Our goal
          is to make it as easy as possible for the buyers to obtain what they
          want at very affordable and discounted prices.
        </Typography>
        <Typography variant="body1" gutterBottom className={classes.paragraph}>
          The products, prices and availability we offer are accurate as of the
          date/time posted and the content/promo is subject to change anytime.
          We suggest all the buyers to please check the same before confirming
          the deal. We further assure you that we will neither collect nor store
          your personal information/data on our website. The hyperlinks in this
          site are automatically converted into affiliate links, which means we
          may earn a small commission if a reader clicks through and make a
          purchase.
        </Typography>
        <Typography variant="body1" gutterBottom className={classes.paragraph}>
          All our offers/promotions are independent and is no way influenced by
          anyone. We hope you will love the products we recommend and get the
          best deal while shopping.
        </Typography>
        <Typography variant="body1" gutterBottom className={classes.paragraph}>
          Further, please note,{" "}
          <b>
            Cosmos Offer Club is a participant in various affiliate programs, designed to provide a
            means for sites to earn advertising fees by advertising and linking, without any charges to the buyer.
          </b>
        </Typography>
        <Typography variant="body1" gutterBottom className={classes.paragraph}>
          Good-Luck and Happy Shopping!
        </Typography>
      </div>
    </Container>
  );
}

export default Home;
